/*
 * Jordi: Trusted Shops and Tawk.to are both injected by their own apps (not theme code) as
 * floating, position:fixed widgets with very high z-index, so they can float above normal
 * page content. When the cart drawer opens, those widgets can end up drawn ON TOP of the
 * drawer instead of behind it (e.g. the Trusted Shops badge covering the iDEAL/Wero payment
 * icon).
 *
 * Rather than hardcoding Tawk.to's / Trusted Shops' exact CSS selectors (which can change
 * whenever those apps update, and which we can't verify live right now), this script is
 * generic: whenever the cart drawer opens (it gets an `active` attribute - see cart.css),
 * it scans the page for any position:fixed element OUTSIDE the drawer with a very high
 * z-index, and temporarily forces it behind the drawer. When the drawer closes, every
 * widget's original z-index is restored exactly, so nothing else about them changes.
 */
(function () {
  var drawer = document.querySelector('cart-drawer#CartDrawer');
  if (!drawer) return;

  var lowered = [];

  function isInsideDrawer(el) {
    return drawer.contains(el);
  }

  function lowerFloatingWidgets() {
    var candidates = document.body.querySelectorAll('*');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (isInsideDrawer(el)) continue;

      var style = window.getComputedStyle(el);
      if (style.position !== 'fixed') continue;

      var z = parseInt(style.zIndex, 10);
      if (isNaN(z) || z < 1000) continue;

      if (el.dataset.wcOriginalZIndex === undefined) {
        el.dataset.wcOriginalZIndex = el.style.zIndex || '';
      }
      el.style.setProperty('z-index', '1', 'important');
      lowered.push(el);
    }
  }

  function restoreFloatingWidgets() {
    lowered.forEach(function (el) {
      var original = el.dataset.wcOriginalZIndex;
      if (original) {
        el.style.zIndex = original;
      } else {
        el.style.removeProperty('z-index');
      }
      delete el.dataset.wcOriginalZIndex;
    });
    lowered = [];
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'active') {
        if (drawer.hasAttribute('active')) {
          lowerFloatingWidgets();
        } else {
          restoreFloatingWidgets();
        }
      }
    }
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['active'] });
})();
